import {OBJECT_CREATED} from '../triggerConstants';
import {DeriveCapabilitiesArgs, DerivedCapabilities} from './types';

export default function deriveCapabilities({
  selectedSchemaSource,
  selectedTrigger,
  triggerKind,
}: DeriveCapabilitiesArgs): DerivedCapabilities {
  const canConfigureFieldChanges = selectedTrigger != null && selectedTrigger.fields.length > 0;

  const objectCreatedDisabled = selectedTrigger == null || !selectedTrigger.supportsCreation;
  const fieldChangesDisabled = selectedTrigger == null || !canConfigureFieldChanges;
  const schemaScopeDisabled = selectedSchemaSource == null;
  const instanceScopeDisabled = triggerKind === OBJECT_CREATED;

  const showObjectCreatedUnavailableTooltip = selectedTrigger != null && !selectedTrigger.supportsCreation;
  const showFieldChangesUnavailableTooltip = selectedTrigger != null && !canConfigureFieldChanges;

  return {
    canConfigureFieldChanges,
    objectCreatedDisabled,
    fieldChangesDisabled,
    schemaScopeDisabled,
    instanceScopeDisabled,
    showObjectCreatedUnavailableTooltip,
    showFieldChangesUnavailableTooltip,
  };
}
